export enum ProductType {
  INBOX = 'inbox',
  AUTOMATION = 'automation',
  GRANDFATHERING = 'grandfathering',
}

export const ProProducts = [ProductType.AUTOMATION, ProductType.INBOX] as const

export type ProProduct = typeof ProProducts[number]

export type RequiredProducts = ProductType[]
